import styled from 'styled-components';

export const DisabledDividerStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 8px 0;

  .icon-wrapper {
    position: absolute;
    z-index: 1;
    background-color: white;
    padding: 0 4px;
  }
  .line {
    position: absolute;
    width: 100%;
    border-top: 1px dashed #8e1f0b;
    z-index: 0;
  }
`;
